const showOrderForm = () => {
  window.Widget.ticketsController.emit(
    window.Widget.ticketsController.events.TOGGLE_ORDER_FORM,
    true,
  );
  window.Widget.schemaIsBroken = true;
  throw Error('empty schema');
};

export const validateSettings = () => {
  if (!window.Widget.settings.eventHallLayoutId) {
    showOrderForm();
  }
};

export const validateSchema = (data) => {
  if (!data.height || !data.width || !data.bg) {
    showOrderForm();
  }
};
